// extracted by mini-css-extract-plugin
export default {"schedule":"Schedule_schedule__gd7li","title":"Schedule_title__D3v8a","tableWrap":"Schedule_tableWrap__LSeFe","btn":"Schedule_btn__lc9-M"};